import React from "react";
import "./ColumnColors.scss";

const objectColors = {
  "Miễn phí": {
    color: "#EC2E06",
    label: "Free",
  },
  "Thanh toán": {
    color: "#00b335",
    label: "Paid",
  },
  "Thẻ gia đình": {
    color: "#434343",
    label: "Free Family",
  },
  "Giảm giá": {
    // color: "#00b335",
    // label: "Paid",
  },
  "Thẻ khám miễn phí 1 lần": {
    color: "#CC0000",
    label: "Khám đoàn",
  },
  "Khám đoàn": {
    color: "#3380FF",
    label: "Free Post OP",
  },
  "Khám lại sau mổ": {
    color: "#FF9900",
    label: "Free Family",
  },
  "Gói khám": {
    label: "Free Package",
    color: "#45818E",
  },
};
const PatientTypeColumn = ({ label }: { label: string }) => {
  return (
    <div
      className="color-column"
      style={{
        backgroundColor: label ? (label === "VIP" ? "#81F3BD" : "red") : "",
      }}
    >
      {label}
    </div>
  );
};

export default PatientTypeColumn;
